import { render, staticRenderFns } from "./QAForm.vue?vue&type=template&id=1d767b86&scoped=true"
import script from "./QAForm.vue?vue&type=script&lang=js"
export * from "./QAForm.vue?vue&type=script&lang=js"
import style0 from "./QAForm.vue?vue&type=style&index=0&id=1d767b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d767b86",
  null
  
)

export default component.exports